import type * as Api from '../model/types'

import store from '../../../redux/store'
import { actions } from '../model/slice'

function saveConversations(response: Api.ConversationResponse) {
	const { items } = response
	const action = actions.addConversations(items)
	store.dispatch(action)

	return response
}

function saveMessages(response: Api.EventsResponse) {
	const { items } = response
	const action = actions.addMessages(items)
	store.dispatch(action)

	return response
}

export { saveConversations, saveMessages }
